"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var react_text_mask_1 = __importDefault(require("react-text-mask"));

var yup_1 = require("yup");

var Base_1 = __importDefault(require("./Base"));

var Input_styles_1 = require("./Base/Input.styles");

exports.TextMaskedInput = styled_components_1.default(react_text_mask_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), Input_styles_1.inputCss); // eslint-disable-next-line prettier/prettier

var zipCodeMask = [/\d/, /\d/, /\d/, /\d/, /\d/];
exports.schema = yup_1.string().required('Zip code is required');

var ZipCode = function ZipCode(props) {
  return react_1.default.createElement(Base_1.default, __assign({
    label: "Zip Code",
    InputComponent: exports.TextMaskedInput,
    required: true,
    mask: zipCodeMask
  }, props));
};

exports.default = ZipCode;
var templateObject_1;